// Student Editor - PartDPage2 (Large view, matches teacher layout - readonly)
import React from 'react';

const PartDPage2 = ({ activity }) => {
  const teacherFields = activity?.part_d?.page_2?.teacher_fields || {};

  const getTotalChecked = (category) => {
    if (!category) return 0;
    return [
      category.item_1_checked,
      category.item_2_checked,
      category.item_3_checked,
      category.item_4_checked,
      category.item_5_checked
    ].filter(Boolean).length;
  };

  const renderAssessmentCategory = (category, title) => {
    const categoryData = teacherFields[category] || {};
    const totalChecked = getTotalChecked(categoryData);

    return (
      <div style={{ marginBottom: '25px' }}>
        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
          {/* Orange Label */}
          <div style={{
            backgroundColor: '#F4824C',
            color: 'white',
            padding: '20px 30px',
            fontSize: '16px',
            fontWeight: 'bold',
            minWidth: '150px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px'
          }}>
            {title}
          </div>

          {/* Main Content Area */}
          <div style={{
            flex: 1,
            backgroundColor: '#FFE5D5',
            padding: '20px',
            borderRadius: '4px'
          }}>
            {/* Instructions */}
            <div style={{ fontSize: '15px', marginBottom: '15px', lineHeight: '1.5' }}>
              Based on the type of interaction, choose <strong>five</strong> assessment parameters from
              page 36-37. Tick (✓) as per the learner's performance.
            </div>

            {/* Assessment Items Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
              {/* Left Column - 3 items */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[1, 2, 3].map(num => (
                  <div key={num} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '20px', minWidth: '20px' }}>{categoryData[`item_${num}_checked`] ? '☑' : '☐'}</span>
                    <div style={{
                      flex: 1,
                      borderBottom: '2px solid #999',
                      fontSize: '15px',
                      paddingBottom: '8px',
                      minHeight: '30px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {categoryData[`item_${num}`] || ''}
                    </div>
                  </div>
                ))}
              </div>

              {/* Right Column - 2 items */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[4, 5].map(num => (
                  <div key={num} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '20px', minWidth: '20px' }}>{categoryData[`item_${num}_checked`] ? '☑' : '☐'}</span>
                    <div style={{
                      flex: 1,
                      borderBottom: '2px solid #999',
                      fontSize: '15px',
                      paddingBottom: '8px',
                      minHeight: '30px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {categoryData[`item_${num}`] || ''}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Total Count */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Total number of (✓):</span>
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                border: '4px solid #F4824C',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: 'white'
              }}>
                {totalChecked}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '30px',
      backgroundColor: 'white',
      fontFamily: "'Poppins', Arial, sans-serif"
    }}>
      {/* Header */}
      <div style={{
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '15px',
        marginBottom: '20px',
        borderRadius: '4px'
      }}>
        Teacher Assessment
      </div>

      {/* Readonly Note */}
      <div style={{
        backgroundColor: '#E3F2FD',
        border: '2px solid #2196F3',
        padding: '15px',
        marginBottom: '25px',
        fontSize: '14px',
        color: '#1565C0',
        textAlign: 'center',
        fontStyle: 'italic',
        borderRadius: '4px'
      }}>
        This page is filled by your teacher. You can view the assessment below.
      </div>

      {/* Three Assessment Categories */}
      {renderAssessmentCategory('awareness', 'Awareness')}
      {renderAssessmentCategory('sensitivity', 'Sensitivity')}
      {renderAssessmentCategory('creativity', 'Creativity')}

      {/* Brief Comments Section */}
      <div style={{
        backgroundColor: '#FFE5D5',
        padding: '20px',
        marginTop: '25px',
        borderRadius: '4px'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '12px' }}>
          Brief comments and pedagogical interventions recommended:
        </div>
        <div style={{
          fontSize: '15px',
          lineHeight: '1.6',
          minHeight: '150px',
          whiteSpace: 'pre-wrap',
          padding: '10px',
          backgroundColor: 'rgba(255,255,255,0.5)',
          borderRadius: '4px'
        }}>
          {teacherFields.brief_comments || <span style={{ color: '#999', fontStyle: 'italic' }}>No comments provided yet</span>}
        </div>
      </div>
    </div>
  );
};

export default PartDPage2;
